import React, { useCallback, useRef, useState } from 'react';
import { UploadCloud } from 'lucide-react';

export const UploadDropzone = ({ onFilesSelected, disabled }) => {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  const openPicker = () => {
    if (!disabled && inputRef.current) inputRef.current.click();
  };

  const onDrop = useCallback((e) => {
    e.preventDefault();
    setDragging(false);
    if (disabled) return;
    if (e.dataTransfer?.files?.length) onFilesSelected(e.dataTransfer.files);
  }, [disabled, onFilesSelected]);

  const onChange = (e) => {
    if (e.target.files?.length) onFilesSelected(e.target.files);
    e.target.value = ''; // allow re-selecting the same file
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={onDrop}
      onClick={openPicker}
      data-testid="upload-dropzone"
      className={`
        rounded-xl border-2 border-dashed cursor-pointer transition
        px-6 py-10 text-center
        ${dragging ? 'border-emerald-400 bg-emerald-500/5' : 'border-slate-700 bg-slate-900'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:border-emerald-500/60 hover:bg-slate-900/60'}
      `}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        onChange={onChange}
        className="hidden"
        data-testid="upload-input"
        accept="image/*,application/pdf,text/plain,text/html,application/zip,application/x-zip-compressed,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />
      <UploadCloud className={`w-8 h-8 mx-auto mb-3 ${dragging ? 'text-emerald-400' : 'text-slate-500'}`} />
      <div className="text-slate-200 font-medium">
        Drop project files here, or <span className="text-emerald-400 underline">browse</span>
      </div>
      <div className="text-xs text-slate-500 mt-2 max-w-xl mx-auto leading-relaxed">
        Assessment outputs (EPC, BRUKL, iSBEM/G-iSBEM), survey photographs, hand-drawn plans,
        site notes, research and technical documents. Originals are preserved unchanged.
        <span className="block mt-1 text-slate-400">
          .zip archives of photos are auto-expanded — every entry becomes its own file.
        </span>
      </div>
    </div>
  );
};
